import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { Dto, IProfileResource } from '../../../data';
import { IProfileSecurityResource, IUserResource } from './../';
import { ISessionService, IToastMessageService } from './../../../services';
let template = require('./security-question-card.html');

class SecurityQuestionCardComponent extends ComponentRegistration {

    constructor() {
        super('securityQuestionCard', {
            controller: SecurityQuestionCardController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
                ngDisabled: "=",
                onSuccess:"&?"
            }
        });
    }
}

interface ISecurityQuestionCardController {
    loadCurrentQuestion(): void;
    clearAnswer(): void;
    onCancel(): void;
    onSave(): void;
    saveAnswer(): void;
}

class SecurityQuestionCardController implements ISecurityQuestionCardController {
    private static $inject: Array<string> = ['$timeout', 'Session', 'User', 'Profile', 'toastMessageFactory'];

    //private fields
    private question: string = '';
    private answer: string = '';
    private securityForm: ng.IFormController;
    private isEditMode: Boolean = true;
    private onSuccess: Function;
    //bindings
    private ngDisabled: Boolean;

    constructor(private $timeout: ng.ITimeoutService,
        private Session: ISessionService,
        private User: IUserResource,
        private Profile: IProfileResource,
        private toastMessageFactory: IToastMessageService) {

        console.log('SecurityQuestionCardController loaded');

    }

    public $onInit(): void {
        this.loadCurrentQuestion();
        console.log('SecurityQuestionCardController activated');
    }

    public loadCurrentQuestion(): void {
        this.Session.getSessionAsync().then((current) => {
          
            if (current && current.profile && current.profile.securityQuestion) {
                this.question = current.profile.securityQuestion.id;
            }
        });
    }

    public clearAnswer(): void {
        this.answer = '';
        this.securityForm.$setUntouched();
        this.securityForm.$setPristine();    
    }

    public onCancel(): void {
        this.clearAnswer();
    }

    public onSave(): void {
        this.saveAnswer();
    }

    public raiseOnSuccess() {
        if (this.onSuccess)
            this.onSuccess();
    }

    public saveAnswer(): any {
        this.Session.getSessionAsync().then((current) => {
            if (current && current.profile) {
                var answer = { securityAnswer: this.answer } as Dto.ISecurityQuestionAnswer;
                var userRouteVars = { id: current.profile.id };

                return this.User.changeAnswer(userRouteVars, answer).$promise
                    .then((response) => {
                        var question = { id: this.question } as Dto.ISecurityQuestion;
                        var routeVars = {
                            id: current.profile.id ,                        
                            accountId: (current.account) ? current.account.id : null
                        };
                        var method = (current.account) ? 'saveQuestion' : 'saveAdminQuestion';
                        (this.Profile as any)[method](routeVars, question).$promise
                            .then(() => {
                                this.toastMessageFactory.showSuccessMessage();
                                this.raiseOnSuccess();
                                this.clearAnswer();
                                                                           
                            }) 
                            .catch((e) => {
                                console.log(e);
                            });
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
        });
    }

}

let sqcardComponent = new SecurityQuestionCardComponent();
export default sqcardComponent;
export { sqcardComponent as SecurityQuestionCardComponent, ISecurityQuestionCardController, SecurityQuestionCardController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/security/user-controls/security-question-card.ts